import { postData } from '../fetch'

function getAuthorizationHeader (token) {
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export function postWenJetSo (path, bodyJson, token, options) {
  const apiDomain = process.env.GATSBY_WENJETSO_API_DOMAIN || ''
  return postData(`${apiDomain}${path}`, bodyJson, getAuthorizationHeader(token), options)
}